(function ($) {
  $(document).ready(function () {
    $(".filter .selector-wrap .selector").on("click", function () {
      var $parent = $(this).parent();
      $parent.toggleClass("active");
      $(".filter .selector-wrap").not($parent).removeClass("active");
    });

    $(document).on("click", function (event) {
      if (!$(event.target).closest(".selector-wrap").length) {
        $(".filter .selector-wrap").removeClass("active");
      }
    });
  });
})(jQuery);